import { Hbml, HbmlElementNode, HbmlNode, isElementNode, isElementNodeOfType, isEmptyElement } from "..";

/**
 * Sanitization is a process of fixing totally absurd HBML that sometimes is still persisted in ProductContent table.
 * Until we fix the the parsing to HBML process we need to keep sanitizing HBML
 */
export function sanitizeHbml(content: Array<unknown> | Record<string, unknown>): Hbml {
    if (Array.isArray(content)) {
        return content
            .flatMap((node) => {
                return sanitizeNode(node);
            })
            .filter((x) => x) as Hbml;
    } else {
        return sanitizeNode(content) as Hbml;
    }
}

function sanitizeNode(node: unknown) {
    // unwrap element without type
    if (typeof node === "object" && node !== null) {
        if ("children" in node && !("type" in node)) {
            return sanitizeChildren(node.children as Array<unknown>);
        }

        if (isElementNodeOfType(node as HbmlNode, "paragraph")) {
            // remove empty paragraph
            if (isEmptyElement(node as HbmlElementNode)) {
                return undefined;
            }

            return {
                ...node,
                children: unwrapParagraphContent((node as HbmlElementNode).children),
            };
        }

        if (isElementNode(node as HbmlNode)) {
            return {
                ...node,
                children: sanitizeChildren((node as HbmlElementNode).children),
            };
        }
    }

    return node;
}

function sanitizeChildren(children: Array<unknown>) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const newChildrenNodes = sanitizeHbml(children).filter((x) => x);
    if (newChildrenNodes.length === 0) {
        return [{ text: "" }];
    }
    return newChildrenNodes;
}

function unwrapParagraphContent(node: Array<unknown>): Array<unknown> {
    return node.flatMap((node) => {
        if (isElementNode(node as HbmlElementNode)) {
            return unwrapParagraphContent((node as HbmlElementNode).children);
        }

        return node;
    });
}
